import { analyticsAPI } from "services/apis.service";

export class GroupAnalyticsService {
  #axios;
  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  async getAnalyticsOverviewData(timeframe) {
    try {
      const { data } = await this.#axios.get(
        `${analyticsAPI.getGroupOverview}?DataFrequency=${timeframe}`
      );
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
